import { observer } from 'mobx-react-lite';
import {
  CheckboxField,
  FieldGroup,
  TextField,
  Widget,
  WidgetProps,
} from '../../../../../components';
import Product from '../../../store/Product';

export default observer(function HiseWidget({
  product,
  ...rest
}: { product: Product } & WidgetProps) {
  return (
    <Widget surface="gray" title="HISE Link" {...rest}>
      <CheckboxField
        label="Generate Link File for Samples"
        name="enabled"
        onChange={product.extendedFeatures.hiseLink.handleChange}
        sx={{ mt: 0 }}
        value={product.extendedFeatures.hiseLink.enabled}
      />

      {product.extendedFeatures.hiseLink.enabled && (
        <FieldGroup>
          <TextField
            label="Company"
            name="company"
            onChange={product.extendedFeatures.hiseLink.handleChange}
            sx={{ width: 240 }}
            value={product.extendedFeatures.hiseLink.company}
          />
          <TextField
            label="Product"
            name="product"
            onChange={product.extendedFeatures.hiseLink.handleChange}
            sx={{ width: 240 }}
            value={product.extendedFeatures.hiseLink.product}
          />
        </FieldGroup>
      )}
    </Widget>
  );
});
